import eruda from 'eruda';
import { createApp, h } from 'vue';
import NaviParkPanel from '../../eruda/NaviParkPanel.vue';

/**
 * eruda デバッグコンソール
 */
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const config = useRuntimeConfig();
  const appEnv = config.public.env;
  const __DEBUG__ = ['local', 'dev', 'stg'].includes(appEnv as string);

  if (!__DEBUG__) return;

  if (document.querySelector('#eruda')) return;

  eruda.init();

  // NaviPark カスタムプラグインを追加
  eruda.add(function (eruda: any): any {
    class NaviParkTool extends eruda.Tool {
      name = 'NaviPark';
      private vueApp: any = null;
      private style: any = null;

      constructor() {
        super();
        // カスタムスタイルを注入
        this.style = eruda.util.evalCss(`
          .flex { display: flex; }
          .flex-col { flex-direction: column; }
          .gap-4 { gap: 16px; }
          .mb-4 { margin-bottom: 1rem; }
          .navipark-container {
            padding: 20px;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          }
          .navipark-title {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 15px;
          }
          .navipark-head2 {
            font-weight: bold;
          }
          .navipark-input-group {
            margin-bottom: 15px;
            display: flex;
            flex-direction: column;
            gap: 12px;
          }
          .navipark-label {
            display: block;
            margin-bottom: 5px;
            font-size: 14px;
            color: #666;
          }
          .navipark-input {
            width: 100%;
            padding: 10px;
            font-size: 14px;
            border: 1px solid #ddd;
            border-radius: 4px;
            box-sizing: border-box;
          }
          .navipark-url-display {
            width: 100%;
            padding: 10px;
            font-size: 12px;
            background-color: #f5f5f5;
            border: 1px solid #ddd;
            border-radius: 4px;
            word-break: break-all;
            margin-bottom: 8px;
            color: #333;
            font-family: monospace;
          }
          .navipark-button {
            width: 100%;
            padding: 12px;
            font-size: 14px;
            font-weight: bold;
            color: #fff;
            background-color: #007aff;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.2s;
          }
          .navipark-button-small {
            padding: 8px 12px;
            font-size: 13px;
          }
          .navipark-button:active {
            background-color: #0051d5;
          }
          .navipark-button:disabled {
            background-color: #ccc;
            cursor: not-allowed;
          }
        `);
      }

      init($el: any) {
        super.init($el);
        this._$el = $el;

        console.log('NaviParkTool initialized');

        // コンテナ要素を作成
        const container = document.createElement('div');
        container.id = 'navipark-panel-container';

        // ErudaのDOM要素に追加
        const rawEl = $el.get(0);
        if (rawEl) {
          rawEl.appendChild(container);

          // Vueアプリケーションをマウント
          // TailwindはグローバルCSSなので、通常は自動的に適用される
          this.vueApp = createApp({
            render: () => h(NaviParkPanel),
          });

          this.vueApp.mount(container);
          console.log('NaviParkPanel Vue component mounted');
        }
      }

      show() {
        this._$el.show();
      }

      hide() {
        this._$el.hide();
      }

      destroy() {
        super.destroy();
        // Vueアプリケーションをアンマウント
        if (this.vueApp) {
          this.vueApp.unmount();
          this.vueApp = null;
        }
        // スタイルを削除
        if (this.style) {
          eruda.util.evalCss.remove(this.style);
        }
      }
    }

    return new NaviParkTool();
  });
});
